// extracted by mini-css-extract-plugin
module.exports = {"container":"Accordion_container__2NPIh","titleContainer":"Accordion_titleContainer__2ktk2","title":"Accordion_title__CDMEU","contentContainer":"Accordion_contentContainer__11jQI"};